module.exports = __webpack_public_path__ + "static/media/03-1-galeria-04-burberry@2x.378f76ef.jpg";